export const TEST_ID = 'polygonIcon';
